console.log(multipleSelection);
 if (selectorStyle == 'dropdown' ) {
  document.querySelectorAll(".custom-select__option").forEach((option) => {
    option.addEventListener("click", () => {
      const selectedProduct = option.getAttribute("data-id");
      const selectedProductId = option.getAttribute("data-product-id");
      const productTitle = option.getAttribute("data-product-title");
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selectedProduct);
      window.history.replaceState({}, '', url);

     if (option.classList.contains('is-unavailable')) {
        document.querySelector(".product-info__add-button button").setAttribute("disabled", "");
        document.querySelector(".product-info__add-button button").innerText = "Sold out";
      } else {
        document.querySelector(".product-info__add-button button").removeAttribute("disabled");
        document.querySelector(".product-info__add-button button").innerText = "Add to cart";
      }

     // Update price based on selected variant
      document.querySelector(".product-info__price .price__current").innerText = `${option.getAttribute("data-price-current")}`;

      // Update compare at price based on selected variant if it exists
      if (option.getAttribute("data-price-was")) {
        document.querySelector(".product-info__price .price__was").innerText = `${option.getAttribute("data-price-was")}`;
      } else {
        document.querySelector(".product-info__price .price__was").innerText = "";
      }
      
      document.querySelector('.js-product-form input[name="id"]').value = selectedProduct;
      document.querySelector('.js-product-form input[name="id"]').setAttribute("value", selectedProduct);
      document.querySelector('.js-product-form input[name="product-id"]').setAttribute("value", selectedProductId);
      document.querySelector('.js-product-form input[name="product-id"]').value = selectedProductId;
      document.querySelectorAll(".media-thumbs__item img").forEach((image, index) => {
        if(image.alt == productTitle) {
          document.querySelectorAll(".media-thumbs__item button")[index].click();
        }
      })
    })
  });
  
  document.addEventListener('DOMContentLoaded', () => {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    if(variantId) {
      document.querySelector(`.custom-select__option[data-id='${variantId}']`).click();
      document.querySelector(".custom-select__btn .text-start").innerText = `${document.querySelector(`.custom-select__option[data-id='${variantId}']`).getAttribute('data-value')}`;
    } else {
      document.querySelectorAll(".custom-select__option")[0].click();
      document.querySelector(".custom-select__btn .text-start").innerText = `${document.querySelectorAll(".custom-select__option")[0].getAttribute('data-value')}`;
    }
  });
 } else if ( selectorStyle == 'buttons') {
    document.querySelectorAll(".option-selector__btns input[type='radio']").forEach ((button) => {
      button.addEventListener("change", () => {
        const selectedProduct = button.getAttribute("data-id");
        const selectedProductId = button.getAttribute("data-product-id");
        const productTitle = button.getAttribute("data-product-title");
        
        // update url query parameters based on selected variant id
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selectedProduct);
        window.history.replaceState({}, '', url);
        if (button.classList.contains('is-unavailable')) {
          document.querySelector(".product-info__add-button button").setAttribute("disabled", "");
          document.querySelector(".product-info__add-button button").innerText = "Sold out";
        } else {
          document.querySelector(".product-info__add-button button").removeAttribute("disabled");
          document.querySelector(".product-info__add-button button").innerText = "Add to cart";
        }

        // Update price based on selected variant
        document.querySelector(".product-info__price .price__current").innerText = `${button.getAttribute("data-price-current")}`;

        // Update compare at price based on selected variant if it exists
        if (button.getAttribute("data-price-was")) {
          document.querySelector(".product-info__price .price__was").innerText = `${button.getAttribute("data-price-was")}`;
        } else {
          document.querySelector(".product-info__price .price__was").innerText = "";
        }

        // Update add to cart button based on selected variant
        document.querySelector('.js-product-form input[name="id"]').value = selectedProduct;
        document.querySelector('.js-product-form input[name="id"]').setAttribute("value", selectedProduct);
        document.querySelector('.js-product-form input[name="product-id"]').setAttribute("value", selectedProductId);
        document.querySelector('.js-product-form input[name="product-id"]').value = selectedProductId;

        // Update selected variant image
         document.querySelectorAll(".media-thumbs__item img").forEach((image, index) => {
            if(image.alt == productTitle) {
              document.querySelectorAll(".media-thumbs__item button")[index].click();
            }
          });

        // document.querySelector(".option-selector__label-value").innerText = button.value;
        
      });
    });

    document.addEventListener('DOMContentLoaded', () => {
       const urlParams = new URLSearchParams(window.location.search);
       const variantId = urlParams.get('variant');

       if(variantId) {
         if(multipleSelection = true) {
           document.querySelector(`.option-selector__btns input[type='checkbox'][data-id='${variantId}']`).click();
         } else {
            document.querySelector(`.option-selector__btns input[type='radio'][data-id='${variantId}']`).click();
         }
        } else {
         if(multipleSelection = true) {
           document.querySelectorAll(".option-selector__btns input[type='checkbox']")[0].click();
         } else {
           document.querySelectorAll(".option-selector__btns input[type='radio']")[0].click();
         }
        }
    });
   
 } else if (selectorStyle == 'image') {
    document.querySelectorAll(".option-selector__btns input[type='radio']").forEach ((button) => {
      button.addEventListener("change", () => {
        const selectedProduct = button.getAttribute("data-id");
        const selectedProductId = button.getAttribute("data-product-id");
        const productTitle = button.getAttribute("data-product-title");
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selectedProduct);
        window.history.replaceState({}, '', url);
         if (button.classList.contains('is-unavailable')) {
          document.querySelector(".product-info__add-button button").setAttribute("disabled", "");
          document.querySelector(".product-info__add-button button").innerText = "Sold out";
        } else {
          document.querySelector(".product-info__add-button button").removeAttribute("disabled");
          document.querySelector(".product-info__add-button button").innerText = "Add to cart";
        }

         // Update price based on selected variant
        document.querySelector(".product-info__price .price__current").innerText = `${button.getAttribute("data-price-current")}`;

        // Update compare at price based on selected variant if it exists
        if (button.getAttribute("data-price-was")) {
          document.querySelector(".product-info__price .price__was").innerText = `${button.getAttribute("data-price-was")}`;
        } else {
          document.querySelector(".product-info__price .price__was").innerText = "";
        }

        
        document.querySelector('.js-product-form input[name="id"]').value = selectedProduct;
        document.querySelector('.js-product-form input[name="id"]').setAttribute("value", selectedProduct);
        document.querySelector('.js-product-form input[name="product-id"]').setAttribute("value", selectedProductId);
        document.querySelector('.js-product-form input[name="product-id"]').value = selectedProductId;
         document.querySelectorAll(".media-thumbs__item img").forEach((image, index) => {
            if(image.alt == productTitle) {
              document.querySelectorAll(".media-thumbs__item button")[index].click();
            }
          });

        document.querySelector(".option-selector__label-value").innerText = button.value;
        
      });
    });

   document.addEventListener('DOMContentLoaded', () => {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      if(variantId) {
          document.querySelector(`.option-selector__btns input[type='radio'][data-id='${variantId}']`).click();
        } else {
           document.querySelectorAll(".option-selector__btns input[type='radio']")[0].click();
        }
    });

   
 } else if (selectorStyle == 'color') {
   document.querySelectorAll(".option-selector__btns input[type='radio']").forEach ((button) => {
      button.addEventListener("change", () => {
        const selectedProduct = button.getAttribute("data-id");
        const selectedProductId = button.getAttribute("data-product-id");
        const productTitle = button.getAttribute("data-product-title");
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selectedProduct);
        window.history.replaceState({}, '', url);
         if (button.classList.contains('is-unavailable')) {
          document.querySelector(".product-info__add-button button").setAttribute("disabled", "");
          document.querySelector(".product-info__add-button button").innerText = "Sold out";
        } else {
          document.querySelector(".product-info__add-button button").removeAttribute("disabled");
          document.querySelector(".product-info__add-button button").innerText = "Add to cart";
        }

         // Update price based on selected variant
        document.querySelector(".product-info__price .price__current").innerText = `${button.getAttribute("data-price-current")}`;

        // Update compare at price based on selected variant if it exists
        if (button.getAttribute("data-price-was")) {
          document.querySelector(".product-info__price .price__was").innerText = `${button.getAttribute("data-price-was")}`;
        } else {
          document.querySelector(".product-info__price .price__was").innerText = "";
        }

        
        document.querySelector('.js-product-form input[name="id"]').value = selectedProduct;
        document.querySelector('.js-product-form input[name="id"]').setAttribute("value", selectedProduct);
        document.querySelector('.js-product-form input[name="product-id"]').setAttribute("value", selectedProductId);
        document.querySelector('.js-product-form input[name="product-id"]').value = selectedProductId;
         document.querySelectorAll(".media-thumbs__item img").forEach((image, index) => {
            if(image.alt == productTitle) {
              document.querySelectorAll(".media-thumbs__item button")[index].click();
            }
          });

        document.querySelector(".option-selector__label-value").innerText = button.value;
        
      });
    });

   document.addEventListener('DOMContentLoaded', () => {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
     
      if(variantId) {
          document.querySelector(`.option-selector__btns input[type='radio'][data-id='${variantId}']`).click();
        } else {
           document.querySelectorAll(".option-selector__btns input[type='radio']")[0].click();
        }
    });
 }